export default __webpack_public_path__ + "static/media/Banner - Artisan Pro - Black.ec1185a9.jpg";